/* src/app/private/components/view/courses/create-course/create-course.component.scss */
/*# sourceMappingURL=create-course.component.css.map */
